import styled from 'styled-components';

export const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0 12px;
  height: 34px;
`;

export const TitleText = styled.p`
  display: block;
  max-width: 65%;

  font-size: 1.6rem;
  font-weight: 700;
  color: #111;
  text-align: left;
  line-height: 2.3rem;
`;

export const SelectWrapper = styled.div`
  width: 144px;
`;
